/* eslint-disable */
import React from 'react';
import PropTypes from 'prop-types';
import styles from './revenueByOfferings.module.scss';

const CustomTooltip = React.memo(({ active, payload }) => {
  if (active && payload?.length) {
    return (
      <div className={styles['revenue-offerings-tooltip-main']}>
        <div className={styles['revenue-offerings-tooltip-name']}>
          {payload[0]?.payload?.name}
        </div>
        <div className={styles['revenue-offerings-tooltip-value1']}>
          Total: {payload[0]?.value}
        </div>
        <div className={styles['revenue-offerings-tooltip-value2']}>
          Already Won: {payload[1]?.value}
        </div>
      </div>
    );
  }
  return null;
});

// Prop validation
CustomTooltip.propTypes = {
  active: PropTypes.bool.isRequired,
  payload: PropTypes.arrayOf(
    PropTypes.shape({
      value: PropTypes.number.isRequired,
      payload: PropTypes.shape({
        name: PropTypes.string, 
      }).isRequired,
    })
  ).isRequired,
};

export default CustomTooltip;
